import type { FunctionComponent } from 'react';
import * as T from './KindCompilation.types';
import * as s from './KindCompilation.css';
import Picture from '@media-ui/core/src/components/Picture';
import Text from '@media-ui/core/src/components/Text';
import plural from '@media-ui/core/src/tools/plural';
import classNames from 'classnames';
import Link from '@media-ui/core/src/components/Link';
import { counterTrigger } from 'Src/tools/counters';
const KindCompilation: FunctionComponent<T.IKindCompilationProps> = (props) => {
    const { className, imageList, title, url, kinds_count, clickCounter } = props;
    const handleClick = () => {
        if (clickCounter) {
            counterTrigger(clickCounter);
        }
    };
    return (<div className={classNames(s.root, className)}>
      {imageList?.length && (<div className={s.imageList}>
          {imageList.map((item, index) => {
                return (<Picture className={s.picture} key={index} objectFit="cover" source={{ src: item.src }}/>);
            })}
          <div className={s.count}>
            <Text className={s.countValue} color="contrast">
              {kinds_count}
            </Text>
            <Text type="caption2Caps" color="contrast">
              {plural(kinds_count, 'порода', 'породы', 'пород')}
            </Text>
          </div>
        </div>)}
      <div className={s.content}>
        <Link className={s.link} holder href={url} onClick={handleClick}>
          {title}
        </Link>
      </div>
    </div>);
};
export default KindCompilation;
